import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { CommunicationMethodFormValues } from "src/models/CommunicationMethod.model";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
 

type Props = {
  formikProps: FormikProps<CommunicationMethodFormValues>;
  onClose: () => void;
}; 

const CommunicationTypeOption = [
    {
      label: "One-Way",
      value: "One_Way",
    },
    {
        label: "Two-Way",
        value: "Two_Way",
      },
  ];
  

const CommunicationMethodForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> Form Heading </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Communication Method */}
        <div className="">
          <ATMTextField
            name="communication_method"
            value={values?.communication_method}
            onChange={(e) =>
              setFieldValue("communication_method", e.target.value)
            }
            label="Communication Method"
            placeholder="Enter Communication Method"
            onBlur={handleBlur}
          />
        </div>
        {/* Communication Type */}
        <div className=''>
          <ATMSelectValue
            name='communication_type'
            value={values?.communication_type}
            onChange={(newValue) => setFieldValue('communication_type', newValue)}
            onBlur={handleBlur}
            label='Communication Type'
            placeholder='Select Communication Type'
            options={CommunicationTypeOption}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default CommunicationMethodForm;
